export const attachmentsType = {
  DEFAULT: 0,
  EXPORT: 1,
};